import type { CanceledReasonEnum } from 'src/common/external/bambi-api/bambiApi';
import type { FilterPopoverProps } from 'src/common/primitives/FilterPopover/FilterPopover';
import { FilterPopoverTrigger } from 'src/common/primitives/FilterPopover/FilterPopoverTrigger';
import { MultiSelectFilterPopover } from 'src/common/primitives/FilterPopover/MultiSelectFilterPopover';
import { CANCEL_REASON } from 'src/features/trip/management/cancel/CancelTripModal/cancellationReasons';

type IdentifiedCanceledReason = {
  id: CanceledReasonEnum;
  label: string;
};

// Extracts ID string from list
function unwrapCanceledReasonList(
  list: IdentifiedCanceledReason[]
): CanceledReasonEnum[] {
  return list.map((p) => p.id);
}

function createIdentifiedList(list: CanceledReasonEnum[]) {
  return list.map((s) => ({
    id: s,
    label: s,
  }));
}

const CANCELED_REASON_OPTIONS: CanceledReasonEnum[] =
  Object.values(CANCEL_REASON);

export default function CanceledReasonsColumnFilter({
  selected,
  open,
  triggerElement,
  onApply,
  onClose,
}: {
  selected: CanceledReasonEnum[];
  open?: boolean;
  triggerElement?: FilterPopoverProps['triggerElement'];
  onApply: (canceledReasons: CanceledReasonEnum[]) => void;
  onClose?: () => void;
}) {
  const canceledReasonOptions = CANCELED_REASON_OPTIONS.map((reason) => ({
    id: reason,
    label: reason,
  }));

  return (
    <MultiSelectFilterPopover
      open={open}
      value={createIdentifiedList(selected)}
      filters={canceledReasonOptions}
      renderLabel={(reason) => reason.label}
      triggerElement={
        triggerElement ?? (
          <FilterPopoverTrigger
            count={selected.length}
            label="Canceled Reason"
          />
        )
      }
      onChange={(value) => {
        onApply(unwrapCanceledReasonList(value));
        onClose?.();
      }}
      onCancel={onClose}
    />
  );
}
